export default "__VITE_ASSET__Bdvgsa4w__"